module.exports = SwaggerUIBundle;